module.exports = "https://static.wmbcdn.com/uniweb/images/636a74d25f6d2f37ea0fe91803d55196.svg";